import { v4 as uuidV4 } from 'uuid';
import { sendSystem } from '.';

export const doNimHealthSend = (uuid: string = uuidV4()) =>
  sendSystem({
    scene: 'p2p',
    to: 'health',
    sendToOnlineUsersOnly: false,
    cc: true,
    content: JSON.stringify({ uuid }),
  });
